import React, { useMemo } from "react";
import { useLanguage, useLang } from "../../contexts/LanguageContext";
import { overrides } from "./copy";

// Deep-merge the shared language dictionary with the variant overrides.
// - objects merge recursively
// - arrays merge element-by-element; `null`/`undefined` in the override keeps
//   the shared value at that index, and shared items past the override's length
//   are preserved
// - everything else (strings, functions, React elements) is replaced wholesale
const isPlainObj = (v) =>
  v && typeof v === "object" && !Array.isArray(v) && !React.isValidElement(v);

const mergeValue = (base, over) => {
  if (over === null || over === undefined) return base;
  if (Array.isArray(base) && Array.isArray(over)) {
    return base.map((el, i) => (i < over.length ? mergeValue(el, over[i]) : el));
  }
  if (isPlainObj(base) && isPlainObj(over)) {
    const out = { ...base };
    for (const k in over) out[k] = mergeValue(base[k], over[k]);
    return out;
  }
  return over;
};

// Drop-in replacement for useLanguage() inside variant/* components. Returns the
// shared dictionary with the active language's overrides applied.
export const useVariantCopy = () => {
  const base = useLanguage();
  const { lang } = useLang();
  return useMemo(
    () => mergeValue(base, overrides[lang] || overrides.en),
    [base, lang]
  );
};
